import { getUniqueId } from '@ankr.com/utils/getUniqueId';

export const dashboardCacheTags = {
  getStats: `stats-${getUniqueId()}`,
};
